import { useState, useEffect } from "react"
import { TextField } from "@mui/material"
import { handleZero, deleteZero } from "../../../../helpers/helper"

export const Qty = ({ params, listOfItems, handleQty, approved = false }) => {
    const [qty, setQty] = useState(params.value || '')
    const [disabled, setDisabled] = useState(false)

    const handleQuantity = (e) => {
        const regex = /^(-?\d{0,5})$/i
        if (regex.test(e.target.value)) {
            if (e.target.value < 0 || e.target.value === '-') {
                setQty('')
            }
            else {
                setQty(e.target.value)
                handleQty(e.target.value, params.row.id)
            }
        }
    }

    useEffect(() => {
        if (listOfItems.length >= 0) {
            if(params.row.item_id !== '') {
                const target = listOfItems?.find(i => i.id === params.row.item_id)

                if(target) {
                    setDisabled(false)
                } else {
                    setDisabled(true)
                }
            } else {
                setDisabled(false)
            }
        }
    }, [listOfItems])

    return (
        <TextField
            disabled={params.row.item_id === '' || disabled || approved}
            type="text"
            variant='standard'
            className='w-full mb-5 px-0 pt-0'
            value={qty}
            onChange={(e) => { handleQuantity(e) }}
            onBlur={e => handleZero({
                event: e,
                setter: setQty
            })}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
        />
    )
}
